import { combineReducers } from 'redux';
import UiReducer from './uiReducer';

const rootReducer = combineReducers({
    UiReducer
});

export default rootReducer;